export default {
  page: {
    title: 'Word separator',
    subtitle: 'Tools',
  },
  card: {
    title: 'Word separator',
  },
  form: {
    text: {
      label: 'Paste your text here',
      placeholder: '',
    },
    minWordLength: {
      label: 'Minimum length',
      tooltip:
        'Words with a letter count less than this value will be ignored and will not be counted in the result.',
    },
    variations: {
      label: 'Generate multiple:',
    },
    result: {
      label: 'Generated text',
      placeholder: 'The generated text will appear here',
    },
    repeatedWords: {
      label: 'Repeated words:',
    },
    totalWords: {
      label: 'Total words:',
    },
  },
  table: {
    group: 'Group',
    repeatedWords: 'Repeated words',
    totalWords: 'Total words',
    noContent: 'No text has been generated yet.',
  },
  alert: {
    repeatedWord: 'Repeated word!',
  },
};
